import React from "react";
import Page from "components/Page";
import { Props } from "./CatalogueCategoryCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const CatalogueCategoryCustomTypes = lazyWithRetry(() =>
  import("./CatalogueCategoryCustomTypes")
);

export default (props: Props) => (
  <Page>
    <CatalogueCategoryCustomTypes {...props} />
  </Page>
);
